import http from '@root/utils/axios/admin';

let state = {
    VideosList: [],
    Video: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchVideosList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/videos', { params: filter }).then((response) => {
                commit('setVideosList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchVideo({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/videos/' + id).then((response) => {
                commit('setVideo', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },


}


let mutations = {
    setVideosList(state, data) {
        state.VideosList = data;
    },
    setVideo(state, data) {
        state.Video.data = data;
    },

    setVideoLike(state, id) {
        state.Video.data.is_liked = true;
        state.Video.data.likes_count = state.Video.data.likes_count + 1;
    },
    setVideoUnLike(state, id) {
        state.Video.data.is_liked = false;
        state.Video.data.likes_count = state.Video.data.likes_count - 1;
    },
}

export default {
    state,
    actions,
    mutations
}